import { Directive, HostListener, ElementRef } from '@angular/core';
import { ToastService } from '../services/toast.service';

@Directive({
    selector: '[appRestrictSpecialCharacters]'
})
export class RestrictSpecialCharactersDirective {

    // Define the allowed characters regex
    private regex: RegExp = new RegExp(/^[a-zA-Z0-9\s]*$/);

    constructor(private el: ElementRef, private toasterService: ToastService) { }

    // Listen for the 'paste' event
    @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
        // Get the pasted data from the clipboard
        let clipboardData = event.clipboardData || (window as any).clipboardData;
        let pastedText = clipboardData.getData('text');

        // Check if the pasted text contains only allowed characters
        if (!this.regex.test(pastedText)) {
            event.preventDefault();
            // Optionally, you can provide feedback to the user here
            this.toasterService.show(`Special characters are not allowed !`, {
                class: 'danger',
                title: 'Alert',
            });
        }
    }

    // Listen for the 'keypress' event to prevent typing special characters
    @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
        let key = String.fromCharCode(event.which);
        if (!this.regex.test(key)) {
            event.preventDefault();
            // Optionally, you can provide feedback to the user here
            this.toasterService.show(`Special characters are not allowed !`, {
                class: 'danger',
                title: 'Alert',
            });
        }
    }
}
